<template>
  <div class="custom-text-container">
    <div v-if="loading" class="custom-text-loading">{{ loadingText }}</div>
    <div v-if="error" class="custom-text-error">{{ errorText }}</div>
    <div v-html="content" class="custom-text-content"></div>
    <div v-if="!loading && !error && !content" class="custom-text-empty">{{ emptyText }}</div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'CustomText',
  props: {
    sectionName: {
      type: String,
      required: true
    },
    loadingText: {
      type: String,
      default: 'Cargando contenido...'
    },
    errorText: {
      type: String,
      default: 'Error al cargar el contenido'
    },
    emptyText: {
      type: String,
      default: 'Contenido no disponible'
    }
  },
  data() {
    return {
      content: '',
      loading: false,
      error: false
    }
  },
  watch: {
    sectionName: {
      immediate: true,
      handler() {
        this.fetchContent()
      }
    }
  },
  methods: {
    async fetchContent() {
        this.loading = false
        this.error = false
        this.content = ''
        const url = '/custom-texts/' + this.sectionName;
        axios.get(url)
            .then(response => {
                this.content = response.data.text.content
            });
        this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CustomText.vue